import { styled } from "styled-components";
import { VStack } from "@/components/layout/Layout.tsx";
import { Card } from "@/components/layout/Card.tsx";

export {
  ToggleButton as ModeButton,
  ToggleGroup as ButtonGroup,
} from "@/components/forms/ToggleGroup.tsx";

export const SettingsCard = styled(Card)`
  width: 40%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg};
`;

export const GameSettingsContainer = styled(VStack)`
  gap: ${({ theme }) => theme.spacing.md};
`;

export const SettingsRow = styled(VStack)`
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const SettingsHeader = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: bold;
`;

export const SettingsLabel = styled.label`
  font-size: 12px;
  font-weight: bold;
`;
